"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useRef, useState } from "react";
import { createCategory } from "../../firebase/categories";
import DialogSuccess from "./DialogSuccess";
import { useAtom } from "jotai";
import { showCreateCategoryModalAtom } from "../../store";

export default function DialogCreateCategory({
    open,
    onClose
}) {
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [preview, setPreview] = useState(null)
    const [categoryImage, setCategoryImage] = useState(null)
    const [categoryName, setCategoryName] = useState(null)
    const [activeNext, setActiveNext] = useState(false)
    const [step, setStep] = useState(1)
    const [subCategories, setSubCategories] = useState([])
    const subCategoryRef = useRef(null)
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const [showCreateCategoryModal, setShowCreateCategoryModal] = useAtom(showCreateCategoryModalAtom)

    useEffect(() => {
        setActiveNext(categoryName !== null && preview !== null && categoryName !== '')
    }, [preview, categoryName])

    useEffect(() => {
        setStep(1)
        setCategoryName(null)
        setPreview(null)
        setCategoryImage(null)
        setSubCategories([])
    }, [showCreateCategoryModal])

    const formatDate = (date) => {
        const dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`

        return `${dateString}`
    }

    const addSubCategory = () => {
        if (subCategoryRef.current.value !== '' && !subCategories.includes(subCategoryRef.current.value)) {
            setSubCategories([...subCategories, subCategoryRef.current.value])
        }
    }

    const removeSubCategory = (cat) => {
        let temp = subCategories.reduce((acc, cur) => {
            if (cur !== cat) acc.push(cur)
            return acc
        }, [])

        setSubCategories(temp)
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        setCategoryImage(file)
        if (file) {
            setPreview(URL.createObjectURL(file))
        }
    }

    const publishCategory = () => {
        createCategory(categoryImage, categoryName, subCategories)
        setShowCreateCategoryModal(false)
        setShowSuccessDialog(true)
    }

    return (
        <>
            <DialogSuccess
                message="Category is successfully added"
                open={showSuccessDialog}
                onClose={() => setShowSuccessDialog(false)}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden w-[550px] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                        >
                            <div className="w-full flex flex-col relative p-6 min-h-[484px]">
                                <div className="flex justify-between">
                                    <div className="flex">
                                        <span className="text-primary text-[28px]">Create Category</span>
                                    </div>

                                    <button
                                        onClick={onClose}
                                        className="top-2 right-2 cursor-pointer z-[1]"
                                    >
                                        <img
                                            src="/assets/icons/icon-close.svg"
                                            alt="Close"
                                            className="invert cursor-pointer"
                                        />
                                    </button>
                                </div>

                                {
                                    step === 1 &&
                                    <>
                                        <div className="mt-8">
                                            <input
                                                className="text-[43px] text-white bg-transparent leading-[1.1em]"
                                                placeholder="Category name"
                                                onChange={(e) => setCategoryName(e.currentTarget.value)}
                                            />
                                        </div>

                                        <div className="mt-7">
                                            <div className="text-sm text-primary mb-2">
                                                Add hero photo
                                            </div>

                                            <div className="flex text-[#959595] text-sm">
                                                <img src="/assets/icons/icon-info-white.svg" alt="info" className="mr-2" />
                                                <span>500x500 / Max size 5 MB. Use PNG, JPG or JPEG formats.</span>
                                            </div>

                                            <div className="flex items-center w-fit mt-3">
                                                {preview && <img src={preview} className="w-[68px] h-[68px] object-cover rounded-[10px] mr-2" alt="img" />}

                                                <input
                                                    type="file"
                                                    // accept={acceptedTypes}
                                                    onChange={handleFileChange}
                                                    style={{ display: "none" }}
                                                    id="image-upload"
                                                // ref={fileInputRef}
                                                />

                                                <label htmlFor="image-upload" className="text-white font-thin text-xs">
                                                    <div className="flex items-center px-8 py-3 rounded-[10px] bg-primary cursor-pointer">
                                                        Browse file
                                                    </div>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="flex mt-auto text-[#959595] text-sm justify-end">
                                            <button className="w-[143px] h-[42px]" onClick={onClose}>
                                                Cancel
                                            </button>

                                            <button
                                                className={`w-[143px] h-[42px]  rounded-[10px] ${activeNext ? 'bg-primary text-white' : 'bg-[#E5E5E5]'}`}
                                                onClick={() => setStep(2)}
                                                disabled={!activeNext}
                                            >
                                                Next Step
                                            </button>
                                        </div>
                                    </>
                                }

                                {
                                    step === 2 &&
                                    <>
                                        <div className="mt-8 text-[#989898]">
                                            Add Sub Category:
                                        </div>

                                        <div className="mt-3 mb-10">
                                            <div className="text-sm text-[#989898] mb-2">
                                                Name
                                            </div>

                                            <div className="flex justify-between text-sm">
                                                <input className=" rounded-[10px] w-full mr-2 pl-3" placeholder="Sub Category" id="sub-category" ref={subCategoryRef} />

                                                <button className="px-6 py-3 bg-primary text-white text-xs rounded-[10px]" onClick={addSubCategory}>Add</button>
                                            </div>

                                            <div className="text-sm text-[#989898] mb-2 mt-7">
                                                Sub Category:
                                            </div>

                                            <div className="flex items-center w-fit flex-wrap">
                                                {subCategories.map((cat, index) =>
                                                    <div key={`${cat}-${index}`} className="relative text-white text-xs bg-primary px-3 py-2 rounded-[10px] mr-2 mt-3">
                                                        {cat}

                                                        <button className="absolute top-0 -translate-y-1/2 right-0 -mr-1" onClick={() => removeSubCategory(cat)}>
                                                            <img src="/assets/icons/icon-close-circle.svg" alt="close" className="w-[16px]" />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="text-sm text-[#989898] mb-2 mt-7">
                                                Publish Date:
                                            </div>

                                            <div className="text-sm text-[#989898] mb-2 mt-3">
                                                Date
                                            </div>

                                            <input
                                                className="rounded-[10px] w-full mr-2 pl-5 bg-[#272727] text-[#434343] h-[40px]"
                                                value={formatDate(new Date())}
                                            />
                                        </div>

                                        <div className="flex mt-auto text-[#959595] text-sm justify-end">
                                            <button className="w-[143px] h-[42px]">
                                                Cancel
                                            </button>

                                            <button
                                                className={`w-[143px] h-[42px]  rounded-[10px] ${subCategories.length > 0 ? 'bg-primary text-white' : 'bg-[#E5E5E5]'}`}
                                                onClick={publishCategory}
                                                disabled={subCategories.length === 0}
                                            >
                                                Publish
                                            </button>
                                        </div>
                                    </>
                                }
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
